import { enumValues, number, object, string } from "../../../types/_types";

import distributionPriceTypes from "../../distribution/constants/distributionPriceTypes";

export const ArticlePrice = object({
	type: enumValues(distributionPriceTypes),
	currency: string(3),
	amount: number(),
});
